import { ThunkAction, ThunkDispatch } from "redux-thunk";
import { getRedoAction, getUndoAction, State } from "../reducers";

import { UndoableAction } from './index';


export interface Undoable {
    readonly undoEffect: () => Promise<any>,
    readonly redoEffect: () => Promise<any>,
}

export interface NoOpAction extends Undoable {
    readonly type: 'NOOP',
}

export interface UndoAction {
    readonly type: 'UNDO',
    readonly undoAction: UndoableAction,
}

export interface RedoAction {
    readonly type: 'REDO',
    readonly redoAction: UndoableAction,
}

export async function noEffect() { return; }

export function noop(): NoOpAction {
    return {
        type: 'NOOP',
        undoEffect: noEffect,
        redoEffect: noEffect,
    };
}

export function undo(): ThunkAction<any, State, any, UndoAction>  {
    return async (dispatch: ThunkDispatch<State, any, UndoAction>, getState: () => State): Promise<any> => {
        const undoAction: UndoableAction = getUndoAction(getState());
        const action = {
            type: 'UNDO',
            undoAction,
        } as UndoAction;
        dispatch(action);
        await undoAction.undoEffect();
    };
}

export function redo(): ThunkAction<any, State, any, RedoAction>  {
    return async (dispatch: ThunkDispatch<State, any, RedoAction>, getState: () => State): Promise<any> => {
        const redoAction = getRedoAction(getState());
        const action = {
            type: 'REDO',
            redoAction,
        } as RedoAction;
        dispatch(action);
        await redoAction.redoEffect();
    };
}



// WEBPACK FOOTER //
// ./src/actions/undo.ts